import { FourUKind } from './types';
import { IconBell, IconCalendar, IconChat, IconList, IconMail, IconPulse, IconSparkle } from './glyphs';

export function FourUIcon({ slug, kind }: { slug?: string; kind: FourUKind }) {
  // Pulse icons get the "fortissimo" accent (warm red / M42 magenta); task icons
  // get the primary accent (honey / lavender). Both swap per-brand through CSS vars.
  const bg =
    kind === 'pulse'
      ? 'linear-gradient(135deg, rgba(var(--accent-glow-rgb), 0.22) 0%, rgba(var(--accent-glow-rgb), 0.08) 100%)'
      : 'linear-gradient(135deg, rgba(var(--accent-rgb), 0.22) 0%, rgba(var(--accent-rgb), 0.08) 100%)';
  const stroke =
    kind === 'pulse'
      ? 'rgba(var(--accent-glow-rgb), 0.92)'
      : 'rgba(var(--accent-rgb), 0.92)';
  return (
    <span
      aria-hidden
      style={{
        flexShrink: 0,
        width: 32,
        height: 32,
        borderRadius: 'var(--sym-radius-badge)',
        background: bg,
        border: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: stroke,
      }}
    >
      <FourUSlugIcon slug={slug} kind={kind} />
    </span>
  );
}

function FourUSlugIcon({ slug, kind }: { slug?: string; kind: FourUKind }) {
  // Map mobile's iconSlug values to compact line icons; anything unmatched falls
  // back to the kind glyph (pulse = orbit, task = sparkle).
  const s = (slug || '').toLowerCase();
  if (s.includes('calendar') || s.includes('meeting')) return <IconCalendar />;
  if (s.includes('chat') || s.includes('message') || s.includes('reply')) return <IconChat />;
  if (s.includes('mail') || s.includes('email')) return <IconMail />;
  if (s.includes('list') || s.includes('task') || s.includes('summary')) return <IconList />;
  if (s.includes('bell') || s.includes('reminder') || s.includes('notify')) return <IconBell />;
  return kind === 'pulse' ? <IconPulse /> : <IconSparkle />;
}
